import { isMockMode, post, simulateDelay } from "../api";

export const updateProduct = (data) => {
	if (isMockMode()) {
		const testData = { success: true };

		return simulateDelay(50, () => testData);
	}

	return post(`Products/Update`, data, {
		successMessage: "Product successfully updated",
	});
};
